import { api, Api } from '../../services/api'
import { ISettingsDataHandler } from './ISettingsDataHandler'

interface IRequestSettingsResponse {
  'orders_refresh_interval': number // 3,
  'eta_refresh_interval': number // 5, // minutes
  'store_id': number // 81,
  'company_id': number // 7,
  'store_name': string // "stimazki holon",
  'company_name': string // "Elad's book chain"
}

export class SettingsDataHandler implements ISettingsDataHandler {
  api: Api
  _apiKey: string | null

  constructor() {
    this.api = api
    this._apiKey = null
  }

  async requestSettings(): Promise<{ storeName: string, refreshInterval: number }> {
    const { data } = await this.api.client.get<IRequestSettingsResponse>('sra_dashboard_settings')

    return {
      storeName: data.store_name,
      refreshInterval: data.orders_refresh_interval * 60 * 1000,
    }
  }
}
